import { Box, TextField, TextFieldVariants } from '@mui/material';
import { FormikProps } from 'formik';
import { ReactNode } from 'react';

type Props = {
  formik: FormikProps<any>;
  name: string;
  label: string;
  isLoading?: boolean;
  placeholder?: string;
  helperText?: string;
  type?: string;
  dataTestId?: string;
  showHelperTextOnError?: boolean | null;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const InioTextField = ({
  formik,
  name,
  isLoading = false,
  label,
  placeholder = label,
  helperText = '\u00a0',
  type = 'text',
  dataTestId,
  showHelperTextOnError = null,
  variant = 'outlined',
  disabled = false,
}: Props) => {
  const value = formik.values[name] || '';
  const rawError = formik.touched[name] ? formik.errors[name] : undefined;
  const msgs = Array.isArray(rawError) ? rawError : rawError != null ? [rawError] : [];
  const hasErrors = msgs.length > 0;

  return (
    <TextField
      variant={variant}
      fullWidth
      type={type}
      label={label}
      placeholder={placeholder}
      onBlur={formik.handleBlur}
      onChange={formik.handleChange}
      value={value}
      name={name}
      error={!!formik.touched[name] && !!formik.errors[name]}
      helperText={
        (showHelperTextOnError !== null
          ? showHelperTextOnError && formik.touched[name] && (formik.errors[name] as ReactNode)
          : true) && (
          <Box {...(dataTestId ? { 'data-test-id': `error-${dataTestId}` } : {})}>
            {hasErrors ? (
              <ul>
                {msgs.map((m, i) => (
                  <li key={i}>{m as ReactNode}</li>
                ))}
              </ul>
            ) : (
              helperText
            )}
          </Box>
        )
      }
      slotProps={{
        inputLabel: {
          shrink: true,
        },
        htmlInput: {
          ...(dataTestId ? { 'data-test-id': dataTestId } : {}),
        },
        formHelperText: {
          sx: { marginLeft: 0 },
        },
      }}
      disabled={isLoading || disabled}
    />
  );
};

export default InioTextField;
